<template>
  <div class="container">
    <exam-header :canClickLogo="true"></exam-header>
    <div class="page-content">
      <div class="page-content-head">
        <div class="page-title-warp">
          <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="title"><i></i>批量创建账号</div>
        </div>
        <div class="page-head-content">
          <div class="page-tab-warp">
            <div :class="['tab',currTab === 0 ? 'active' : '']" @click="handleTab(0)">批量生成账号<i/></div>
            <div :class="['tab',currTab === 1 ? 'active' : '']" @click="handleTab(1)">批量生成记录<i/></div>
          </div>
          <div class="page-head-form" v-if="currTab === 1">
            <el-form :model="filterForm" :inline="true" class="filter-form">
              <el-form-item label="备注:" class="description-input">
                <el-input
                    v-model="filterForm.description"
                    placeholder="请输入">
                </el-input>
              </el-form-item>
              <el-form-item label="操作日期:" class="date-input">
                <el-date-picker
                    v-model="daterange"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="form-btns">
                <el-button type="primary" @click="handleQuery" class="search-btn">查询</el-button>
                <el-button @click="handleReset" class="reset-btn">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-content-body" v-if="currTab === 0">
        <div class="paper-form-warp">
          <div class="remark-warp">
            <p class="form-label"><i>*</i>创建说明</p>
            <el-input  :rows="3"
                       class="remark-input"
                       type="textarea"
                       maxlength="20"
                       :autosize="{ minRows: 3, maxRows: 3}"
                       placeholder="请输入创建账号说明，方便后续查看创建记录"
                       v-model="description">
            </el-input>
          </div>
          <div class="file-warp">
            <div class="form-label-warp">
              <p class="form-label"><i>*</i>上传需要生成的账号信息:<span>（请下载模板进行账号信息填写）</span></p>
              <p class="file-btn"><i class="el-icon-download"></i> <a href="https://athena-static.oss-cn-hangzhou.aliyuncs.com/%E4%B8%98%E7%8F%AD%E6%89%B9%E9%87%8F%E5%88%9B%E5%BB%BA%E8%B4%A6%E5%8F%B7%E6%A8%A1%E6%9D%BF.xlsx" download>下载填写账号模板</a></p>
            </div>
            <div class="upload-file">
              <el-upload :action="uploadUrl"
                         class="upload-file-input"
                         :on-success="handleSuccess"
                         :on-error="handleError"
                         :before-upload="beforeUpload"
                         :on-change="handleFileChange"
                         :file-list="fileList"
                         :http-request="customUpload"
                         :with-credentials="true"
                         :auto-upload="false"
                         :on-exceed="handleExceed"
                         :limit="1"
                         drag
                         accept=".xls,.xlsx">
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">点击或拖拽文件到此处上传</div>
                <div class="el-upload__tip">支持扩展名：xls，xlsx</div>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="page-submit-button">
          <el-button type="primary" @click="handleSubmit" :loading="uploading">提交</el-button>
        </div>
      </div>
       <div class="page-content-body" v-if="currTab === 1">
         <!-- 任务记录表格 -->
         <div class="table-section">
           <el-table
             :data="taskList"
             style="width: 100%"
             v-loading="loading">
             <el-table-column label="序号" width="120" align="center">
               <template slot-scope="scope">
                 {{ scope.row.id }}
               </template>
             </el-table-column>
             <el-table-column prop="description" label="创建说明" min-width="120" align="center">
               <template slot-scope="scope">
                 {{ scope.row.description || '25年上海班学生账号' }}
               </template>
             </el-table-column>
             <el-table-column prop="operationDate" label="创建时间" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatDate(scope.row.createTime) }}
               </template>
             </el-table-column>
             <el-table-column prop="status" label="结果" width="150" align="center">
               <template slot-scope="scope">
                 <div v-if="scope.row.status === 1">
                   <span v-if="scope.row.successCount">成功: {{scope.row.successCount}}</span>  <span v-if="scope.row.failCount">失败: {{scope.row.failCount}}</span>
                 </div>
                 <div v-else> - </div>
               </template>
             </el-table-column>
             <el-table-column prop="status" label="创建状态" width="120" align="center">
               <template slot-scope="scope">
                 <span :class="[getStatusClass(scope.row.status),'status']">
                   <i></i>
                   {{ getStatusText(scope.row.status) }}
                 </span>
               </template>
             </el-table-column>
             <el-table-column label="操作" width="120" align="center">
               <template slot-scope="scope">
                 <el-button
                     :class="['export-btn',scope.row.status === 0 ? 'disabled' : '']"
                   type="text" 
                   @click="handleExport(scope.row)"
                   :disabled="scope.row.status !== 1">
                   导出明细
                 </el-button>
               </template>
             </el-table-column>
           </el-table>
         </div>

         <!-- 分页 -->
         <div class="pagination-section" v-if="taskList.length">
           <div class="pagination-info">
             总共{{ total }}个项目
           </div>
           <div class="pagination-controls">
             <el-pagination
               @current-change="handleCurrentChange"
               :current-page="pageNo"
               :page-size="pageSize"
               layout="prev, pager, next"
               :total="total">
             </el-pagination>
           </div>
         </div>
       </div>
    </div>
    <base-modal class="upload-modal"
                head-img-url=""
                okText="查看记录"
                :show-close="true"
                @ok="() => {
                  this.showUploadModal = false;
                  this.checkTaskList();
                }"
                @close="handleModalClose"
                v-if="showUploadModal">
      <template #title>账号批量创建中</template>
      <div slot="content" class="modal-content">
       <p class="modal-tips">请前往「批量生成记录」中查看创建结果</p>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {Button, Input, Upload, Message, Form, FormItem, Table, TableColumn, DatePicker, Pagination,Loading} from "element-ui";
import ExamHeader from "./components/teacherExamHeader.vue";
import {serverCourseUrl} from "@/api/api";
import {getAuth} from "@/common/js/fetch";
import {createUserTask, updateUserTask,exportUserList} from "@/api/qzTeacher";
import BaseModal from "@/components/baseModal.vue";
import { loadAllDataByPagination, exportToExcel, downloadUrl } from '@/common/js/excelUtils';
import dayjs from 'dayjs';
import {EXAM_LEVEL_TYPE, EXAM_LEVEL_TYPE_ENUM} from "@/common/constant/qz";
export default {
  components: {
    'el-form': Form,
    'el-form-item': FormItem,
    'el-table': Table,
    'el-date-picker': DatePicker,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    'exam-header': ExamHeader,
    'el-input': Input,
    'el-upload':Upload,
    'el-button': Button,
    'base-modal':BaseModal
  },
  data () {
    return {
      description:'',
      uploadUrl: `${serverCourseUrl}v1/resource/upload`,
      file: null, // 改为存储文件对象
      uploading: false,
      showUploadModal:false,
      taskInfo:null,
      currTab:0,
      fileList:[],
      daterange: [],
      filterForm:{
        description:'',
        startTime:null,
        endTime:null,
        status:null
      },
       pageNo:1,
       pageSize:20,
       total:0,
       taskList:[],
       loading: false,
        userInfo:null
    }
  },
  methods: {
    checkTaskList(){
      this.currTab = 1;
      this.getTaskList();
    },
    goBack() {
      this.$router.go(-1);
    },
    getExportData(taskId) {
      if (!taskId) {
        this.$message.warning('任务ID不存在');
        return;
      }
      
      // this.$message.info('正在生成导出文件...');
      let loadingInstance =Loading.service({
        lock: false,
        fullscreen:true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        text: '正在生成导出文件...',
      });

      // 调用导出接口获取数据
      exportUserList(taskId).then(res => {
        if (res.code === 200 && res.body) {
          const data = res.body.taskDetails || [];
          // 定义Excel列配置
          const columns = [
            { key: 'username', title: '用户名称' },
            { key: 'mobile', title: '手机号' },
            { key: 'role', title: '角色', formatter: (val) => {
                const roleMap = {
                  'ADMIN': '管理员',
                  'TEACHER': '老师',
                  'STUDENT': '学生'
                };
              if (Array.isArray(val)) {
                return val.map(role => {
                  return roleMap[role] || role;
                }).join(', ');
              }
              return roleMap[val];
            }},
            { key: 'schoolName', title: '学校名称' },
            { key: 'level', title: '业务类型', formatter: (val) => {
              return EXAM_LEVEL_TYPE_ENUM[val] || val;
            }},
            { key: 'userPassDTO', title: '账号',formatter: (val) => {
              return val ? val?.username : '';
            }},
            { key: 'userPassDTO', title: '密码' ,formatter: (val) => {
                return val ? val.password : '';
              }},
            { key: 'status', title: '创建状态', formatter: (val) => {
              return val === 1 ? '成功' : '失败';
            }},
            { key: 'reason', title: '错误信息' }
          ];
          
          // 生成Excel文件
          const excelUrl = exportToExcel(data, columns, '账号创建明细', {
            sheetName: '创建明细'
          });
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          // 生成文件名
          const filename = `【账号创建记录】_${dayjs().format('YYYY-MM-DD HH:mm:ss')}`;
          loadingInstance.close();
          // 下载文件
          downloadUrl(excelUrl, filename);
          
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败：' + (res.message || '未知错误'));
        }
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败：' + (error.message || '网络错误'));
      });
    },
     handleTab(tab) {
       this.currTab = tab;
       if (tab === 1) {
         // 切换到记录页面时加载数据
         this.getTaskList();
       }
     },
     getTaskList(){
       this.loading = true;
       const params = {
         ...this.filterForm,
         pageNo: this.pageNo -1,
         pageSize: this.pageSize
       };
       updateUserTask(params).then(res=>{
         if(res.code === 200 && res.body){
           this.taskList = res.body.tasks || [];
           this.total = res.body.totalCount || 0;
         }
         this.loading = false;
       }).catch(() => {
         this.loading = false;
       });
     },
     
     handleReset () {
       this.filterForm = {
         description: '',
         startTime: null,
         endTime: null,
         status: null
       };
       this.daterange = [];
       this.pageNo = 1;
       this.getTaskList();
     },
     
     handleQuery(){
       // 处理日期范围
       if (this.daterange && this.daterange.length === 2) {
         this.filterForm.startTime = new Date(this.daterange[0]).valueOf();
         this.filterForm.endTime = new Date(this.daterange[1]).valueOf();
       } else {
         this.filterForm.startTime = null;
         this.filterForm.endTime = null;
       }
       this.pageNo = 1;
       this.getTaskList();
     },
    handleExceed() {
      Message.error('一次最多只能上传一个文件,请删除之前的文件再上传~');
    },
    // 上传前验证
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || 
                     file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isExcel) {
        Message.error('只能上传 Excel 文件!');
        return false;
      }
      if (!isLt10M) {
        Message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    handleModalClose() {
      this.showUploadModal = false
    },
    // 自定义上传方法 - 只存储文件对象，不实际上传
    customUpload(options) {
      const { file, onSuccess, onError } = options;
      
      // 验证文件
      const isExcel = file.type === 'application/vnd.ms-excel' || 
                     file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt10M = file.size / 1024 / 1024 < 10;
      
      if (!isExcel) {
        onError(new Error('只能上传 Excel 文件!'));
        Message.error('只能上传 Excel 文件!');
        return;
      }
      
      if (!isLt10M) {
        onError(new Error('上传文件大小不能超过 10MB!'));
        Message.error('上传文件大小不能超过 10MB!');
        return;
      }
      
      // 存储文件对象
      this.file = file;
      onSuccess({ file: file });
      Message.success('文件选择成功!');
    },

    // 文件选择变化处理
    handleFileChange(file, fileList) {
      console.log('文件选择变化:', file, fileList);
      console.log('file.raw:', file.raw);
      console.log('file:', file);
      
      // 验证文件 - 兼容不同版本的Element UI
      const rawFile = file.raw || file;
      const isExcel = rawFile && (rawFile.type === 'application/vnd.ms-excel' || 
                     rawFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const isLt10M = rawFile && rawFile.size / 1024 / 1024 < 10;
      
      console.log('文件验证 - isExcel:', isExcel, 'isLt10M:', isLt10M);
      console.log('文件类型:', rawFile?.type);
      console.log('文件大小:', rawFile?.size);
      
      if (!isExcel) {
        Message.error('只能上传 Excel 文件!');
        this.file = null;
        this.fileList = [];
        return;
      }
      
      if (!isLt10M) {
        Message.error('上传文件大小不能超过 10MB!');
        this.file = null;
        this.fileList = [];
        return;
      }
      
      // 确保存储的是真正的File对象
      if (!(rawFile instanceof File)) {
        Message.error('文件格式不正确，请重新选择文件');
        this.file = null;
        this.fileList = [];
        return;
      }
      // 存储文件对象
      this.file = rawFile;
      this.fileList = fileList;
    },

    // 上传成功回调
    handleSuccess(response, file, fileList) {
      console.log('上传成功:', fileList);
      this.fileList = fileList;
      // 可以在这里处理上传成功后的逻辑
    },

    // 上传失败回调
    handleError(error, file, fileList) {
      console.error('上传失败:', error);
      this.fileList = fileList;
    },
    // 提交表单
    handleSubmit() {
      // 验证必填项
      if (!this.description.trim()) {
        Message.error('请输入备注信息');
        return;
      }
      
      if (!this.file) {
        Message.error('请选择文件');
        return;
      }

      // 这里可以调用批量创建账号的API
      this.uploading = true;
      this.createUserTask()
    },
     createUserTask(){
       // 检查文件是否存在
       if (!this.file) {
         Message.error('文件不存在，请重新选择文件');
         this.uploading = false;
         return;
       }
       
       // 确保文件是File对象
       if (!(this.file instanceof File)) {
         Message.error('文件格式不正确，请重新选择文件');
         this.uploading = false;
         return;
       }
       // 创建FormData对象来传递文件
       const formData = new FormData();
       // 确保文件作为二进制数据传递
       formData.append('file', this.file);
       formData.append('description',this.description);
       formData.append('competitionType', 'MATHS_TALENTS');
       createUserTask(formData).then(response => {
         console.log('API响应:', response);
         if(response.code === 200 && response.body) {
           this.taskInfo = response.body?.task;
           this.uploading = false;
           this.showUploadModal = true;
           this.file = '';
           this.fileList = [];
           this.description = '';
           // Message.success('批量创建账号成功!');
         }
       }).catch(error => {
         console.error('创建任务失败:', error);
         Message.error('创建任务失败: ' + (error.message || '网络错误'));
       }).finally(() => {
         this.uploading = false;
       })
     },

     // 分页处理
     handleCurrentChange(val) {
       this.pageNo = val;
       console.log(val,'val')
       this.getTaskList();
     },

     // 导出明细
     handleExport(row) {
      const taskId = row.id;
      this.getExportData(taskId);
     },

     // 格式化日期
     formatDate(dateTime) {
       if (!dateTime) return '';
       const date = new Date(dateTime);
       const year = date.getFullYear();
       const month = String(date.getMonth() + 1).padStart(2, '0');
       const day = String(date.getDate()).padStart(2, '0');
       return `${year}.${month}.${day}`;
     },

     // 格式化时间
     formatTime(dateTime) {
       if (!dateTime) return '';
       const date = new Date(dateTime);
       const hours = String(date.getHours()).padStart(2, '0');
       const minutes = String(date.getMinutes()).padStart(2, '0');
       const seconds = String(date.getSeconds()).padStart(2, '0');
       return `${hours}:${minutes}:${seconds}`;
     },

     // 获取状态样式类
     getStatusClass(status) {
       return status === 1 ? 'status-completed' : 'status-processing';
     },

     // 获取状态文本
     getStatusText(status) {
       return status ===1 ? '创建完成' : '创建中';
     }
  }
}

</script>

<style scoped lang="less">
.container{
  background: #EDE4DA;
  min-height: 100vh;
  padding: 72px 0;
  box-sizing: border-box;
  .page-content{
    max-width: 1400px;
    margin: 24px auto 0;
    border-radius: 12rpx;
    .page-content-head{
      background: #FFFFFF;
      padding: 0 40px;
      display: flex;
      align-items: center;
      flex-direction: column;
      height: 184px;
      border-radius: 12px 12px 0 0;
      .page-title-warp{
        position: relative;
        text-align: center;
        width: 100%;
        font-weight: 600;
        margin-top: 36px;
        .back{
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          color: #4E5969;
          i{
            color: #4E5969;
            margin-right: 8px;
          }
        }
        .title{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 600;
          color: #000000;
          i{
            width: 30px;
            height: 30px;
            background: url("./images/user.png") no-repeat center center;
            background-size: cover;
            margin-right: 4px;
          }
        }
      }
      .page-head-content{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .page-tab-warp{
          margin-top: 40px;
          //width: 100%;
          display: flex;
          .tab{
            font-size: 20px;
            font-weight: 500;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #86909C;
            margin-right: 80px;
            line-height: 36px;
            &.active{
              color: #1D2129;
              i{
                width: 68px;
                height: 5px;
                background: #E60012;
                border-radius: 90px;
                margin-top: 2px;
              }
            }
          }
        }
        .page-head-form{
          margin-top: 40px;
          .filter-form{
            flex: 1;
            text-align: left;
            position: relative;
            .el-button{
              height: 36px;
              line-height: 36px;
              text-align: center;
              border-radius: 90px;
              border: none;
              outline: none;
              font-size: 14px;
              font-weight: 500;
              padding: 0 24px;
              &.search-btn{
                background: #E60012;
                color: #fff;
              }
              &.reset-btn{
                background: #F2F3F5;
                color: #000000E5;
              }
            }
            .el-form-item{
              margin-bottom: 0;
              .el-form-item__label{
                color: #000000E5;
              }
            }
          }
        }
      }
    }
    .page-content-body{
      background: #F7F6F5;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding:40px 0;
      .paper-form-warp{
        width: 668px;
        .remark-warp{
          width: 100%;
          margin-bottom: 32px;
          .form-label{
            text-align: left;
            font-size: 18px;
            color: #1D2129;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            i{
              color: #E60012;
              margin-right: 4px;
            }
          }
          .remark-input{
            width: 100%;
            border: none;
            background: #FFFFFF;
            outline: none;
          }
        }
        .file-warp{
          width: 100%;
          .form-label-warp{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
          }
          .form-label{
            text-align: left;
            font-size: 18px;
            color: #1D2129;
            display: flex;
            align-items: center;
            span{
              color: #4E5969;
              font-size: 13px;
              font-weight: 400;
            }
            i{
              color: #E60012;
              margin-right: 4px;
            }
          }
          .file-btn{
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            i{
              color: #3491FA;
            }
            a{
              color: #3491FA;
              margin-left: 8px;
            }
          }
        }
        .upload-file{
          width: 100%;
          background: #FFFFFF;
          height: 184px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          position: relative;
          .upload-file-input{
            height: 100%;
          }
          .el-icon-plus{
            margin-bottom: 10px;
          }
          .el-upload__text{
            font-size: 14px;
            color: #1D2129;
          }
          .el-upload__tip{
            color: #86909C;
            font-size: 12px;
          }
        }
      }
      .page-submit-button{
        margin-top: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        button{
          width: 140px;
          height: 40px;
          border-radius: 90px;
          border:none;
          outline: none;
          font-size: 14px;
          &:first-child{
            color: #1D2129;
            background: #FFFFFF;
            margin-right: 8px;
          }
          &:last-child{
            background: #E60012;
            color: #fff;
          }
        }
      }
      .task-info-warp{
        display: flex;
        margin-top: 80px;
        background: #FFFFFF;
        border-radius: 4px;
        height: 54px;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        width: 668px;
        .file-name{
          color: #1D2129;
          font-size: 14px;
          font-weight: 500;
        }
        .file-status{
          color: #BD9F68;
          font-weight: 400;
          font-size: 14px;
          i{
            margin-right: 4px;
          }
        }
         &.loading{
           .file-status{
             color: #E6A23C;
           }
         }
        &.error{
          .file-name{
            color: #E60012;
          }
          .file-status{
            color: #3491FA;
          }
         }
       }
     }
     
     .table-section {
       width: 100%;
       max-width: 1200px;
       margin-bottom: 32px;
       
       .el-table__header{
         thead{
           color: #000000;
           font-weight: 500;
           tr{
             background: #F7F1E6;
             th{
               background: #F7F1E6;
               border-bottom: none !important;
             }
           }
         }
         height: 60px;
       }
       
       .el-table {
         background: #FFFFFF;
         border-radius: 8px;
         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

         .el-table__header {
           background: #f8f9fa;

           th {
             background: #f8f9fa;
             color: #1D2129;
             font-weight: 600;
             border-bottom: 1px solid #e4e7ed;
           }
         }

         .el-table__body {
           tr {
             &:hover {
               background: #f5f7fa;
             }

             td {
               border-bottom: 1px solid #f0f0f0;
             }
           }
         }
       }
     }

     .pagination-section {
       width: 100%;
       max-width: 1200px;
       display: flex;
       justify-content: flex-end;
       box-sizing: border-box;
       align-items: center;
       padding: 16px 24px;
       .pagination-info {
         font-size: 14px;
         color: #000;
         margin-right: 12px;
       }
       .pagination-controls {
         display: flex;
         align-items: center;
         .el-pagination {
           margin-right: 0;
           .el-pager li {
             background: none;
             &.active {
               background: #E60012;
               color: #fff;
               border-color: #E60012;
             }
           }
         }

         .page-jump {
           display: flex;
           align-items: center;
           font-size: 14px;
           color: #606266;

           span {
             margin: 0 4px;
           }
         }
       }
     }
   }
 }

 // 状态样式
  .status{
    color: #7D8087;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    i{
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }
 .status-completed {
   i {
     background: #BD9F68;
   }
 }
 .status-processing {
   i {
     background: #19B21E;
   }
 }
.upload-modal /deep/ .base-modal_title {
  font-size: 24px;
  font-weight: 600;
  color: #000000E5;
  margin-bottom: 24px;
  width: 100%;
}
.upload-modal /deep/ .base-modal_ft {
  margin-top: 54px;
}
.upload-modal /deep/ .base-modal_cnt{
  min-height: 292px;
}
.upload-modal /deep/ .modal-content{
  .modal-tips{
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #4E5969;
    margin-top: 12px;
  }
  .loaded-warp{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 142px;
    border-radius: 12px;
    background: #F5F6F9;
    margin-top: 24px;
    p{
      color: #1D2129;
      &:first-child{
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        i{
          font-size: 24px;
          margin-right: 8px;
          color: #00B42A;
        }
      }
      &:last-child{
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
  .download-btn{
    margin-top: 24px;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #3491FA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    i{
      font-size: 20px;
      margin-right: 4px;
    }
  }
  .loading-warp{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 68px;
    img{
      width: 48px;
      height: 48px;
      animation: rotating 2s linear infinite;
    }
    p {
      font-size: 16px;
      color: #BD9F68;
      margin-top: 12px;
    }
  }
}
 @keyframes rotating {
   0% {
     transform: rotate(0deg);
   }
   100% {
     transform: rotate(360deg);
   }
 }
 </style>

<style>
/* 全局样式覆盖 */
.container {
  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        thead{
          color: #000000;
          font-weight: 500;
          tr{
            background: #F7F1E6;
            th{
              background: #F7F1E6;
              border-bottom: none !important;
            }
          }
        }
        height: 60px;
      }
    }

    .el-table__body-wrapper {
      .el-table__body{
        .el-table__cell{
          padding: 10px 0;
        }
        tr{
          td{
            .export-btn{
              color: #BD9F68;
              font-size: 13px;
              &.disabled{
                color: #C9CDD4;
              }
            }
            border-bottom: none !important;
          }
        }
      }
    }
  }

  .el-pagination {
    .el-pager li {
      min-width: 32px;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 30px;
      border-radius: 4px;
      margin: 0 2px;
      background: none;
      &.active{
        color: #E60012;
      }
    }

    .btn-prev, .btn-next {
      width: 32px;
      height: 32px;
      line-height: 30px;
      border-radius: 4px;
      background: none;
    }
  }
}
</style>
<style>
.page-head-form{
  .el-form-item__label {
    font-size: 16px;
    font-weight: bold;
    padding: 0 4px 0 0;
    margin-right: 4px;
  }
  .el-date-editor .el-range__icon{
    display: flex;
    align-items: center;
  }
  .el-range-separator{
    display: flex;
    align-items: center;
  }
  .description-input{
    .el-input__inner{
      width: 120px;
    }
  }
  .date-input{
    .el-input__inner{
      width: 280px;
    }
  }
  .el-input__inner{
    height: 40px;
    line-height: 40px;
  }
}
.paper-form-warp{
  .el-textarea__inner{
    border: none;
    width: 100%;
    background: #FFFFFF;
    outline: none;
    border-radius: 4px;
  }
  .el-upload{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-list{
    position: absolute;
    left: 0;
    bottom: -40px;
  }
  .el-upload-dragger{
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>